<div class="min-h-screen text-sm dark:bg-slate-900 p-4 md:p-8 text-slate-600 dark:text-slate-300">
  <div class="animate-fade-in flex flex-col md:flex-row md:items-end justify-between mb-8 gap-4">
    <div>
      <h1 class="text-3xl font-extrabold text-slate-800 dark:text-slate-100 tracking-tight">ตั้งค่าการอนุมัติ</h1>
      <p class="text-slate-500 dark:text-slate-400 mt-2 font-medium">กำหนดลำดับอนุมัติตามเมนูในระบบ</p>
    </div>
    <div class="flex flex-col sm:flex-row items-stretch sm:items-center gap-3 w-full sm:w-auto">
      <button (click)="onRefresh()"
        class="p-3 bg-white/95 dark:bg-slate-900/95 text-slate-500 rounded-2xl shadow-sm border border-slate-100/50 hover:text-amber-500 transition-all flex items-center justify-center h-[46px]">
        <span class="material-icons">refresh</span>
      </button>
      <button *ngIf="canCreate" (click)="openCreate()"
        class="px-6 py-3 bg-amber-400 hover:bg-amber-500 text-white font-bold rounded-2xl shadow-lg flex items-center justify-center gap-2 h-[46px]">
        <span class="material-icons">add_circle</span> สร้าง Config
      </button>
    </div>
  </div>

  <div class="animate-fade-in bg-white/95 dark:bg-slate-900/95 backdrop-blur-sm rounded-[2rem] shadow-2xl border border-slate-100/50 overflow-hidden relative">
    <app-pss-loading *ngIf="isLoading()"></app-pss-loading>

    <div class="p-6 border-b border-slate-100/50 flex flex-col sm:flex-row sm:items-end justify-between gap-4">
      <h3 class="text-lg font-bold text-slate-800 dark:text-slate-100 flex items-center gap-2">
        <span class="material-icons text-amber-500">fact_check</span>
        รายการ Config
      </h3>
      <div class="w-full sm:w-56">
        <label class="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">สถานะ</label>
        <select [ngModel]="filterEnable()" (ngModelChange)="filterEnable.set($event); onFilterChange()"
          class="w-full bg-slate-50 dark:bg-slate-800 border border-slate-200 dark:border-slate-700 text-sm rounded-xl font-bold px-3 py-2.5 outline-none focus:ring-2 focus:ring-amber-200 h-[46px]">
          <option value="all">ทั้งหมด</option>
          <option value="true">เปิดใช้งาน</option>
          <option value="false">ปิดใช้งาน</option>
        </select>
      </div>
    </div>

    <div class="overflow-x-auto min-h-[300px] relative custom-scrollbar">
      <table class="w-full text-left border-collapse" [class.opacity-50]="isLoading()">
        <thead class="sticky top-0 z-20 bg-white/95 dark:bg-slate-900/95 border-b border-slate-100/50">
          <tr class="text-xs font-bold text-slate-400 uppercase tracking-widest">
            <th class="p-4">ชื่อ</th>
            <th class="p-4">เมนู</th>
            <th class="p-4 text-center">ชั้น</th>
            <th class="p-4">Site</th>
            <th class="p-4 text-center">สถานะ</th>
            <th class="p-4 text-center w-[100px]">จัดการ</th>
          </tr>
        </thead>
        <tbody class="divide-y divide-slate-50 dark:divide-slate-800">
          <tr *ngFor="let item of items(); trackBy: trackById"
            class="hover:bg-slate-50/50 dark:hover:bg-slate-800/50 transition-all">
            <td class="p-4 font-semibold text-slate-700 dark:text-slate-200">{{ item.name }}</td>
            <td class="p-4 text-sm">{{ item.menuName }}</td>
            <td class="p-4 text-center font-bold text-slate-600 dark:text-slate-300">{{ item.stepCount }} / {{ item.maxLevelCount }}</td>
            <td class="p-4 text-sm">{{ item.siteName || '-' }}</td>
            <td class="p-4 text-center">
              <span class="inline-flex px-2.5 py-1 rounded-full text-xs font-semibold"
                [ngClass]="item.enable
                  ? 'bg-emerald-50 text-emerald-700 dark:bg-emerald-900/30 dark:text-emerald-400'
                  : 'bg-slate-200 text-slate-600 dark:bg-slate-700 dark:text-slate-300'">
                {{ item.enable ? 'เปิด' : 'ปิด' }}
              </span>
            </td>
            <td class="p-4 text-center">
              <div class="flex items-center justify-center gap-1.5">
                <button *ngIf="canUpdate" (click)="openEdit(item)"
                  class="w-8 h-8 rounded-lg flex items-center justify-center border border-slate-100 dark:border-slate-700 hover:border-amber-400 text-slate-400 hover:text-amber-500 transition-all"
                  title="แก้ไข">
                  <span class="material-icons text-base">edit</span>
                </button>
                <button *ngIf="canDelete" (click)="openDeleteConfirm(item)"
                  class="w-8 h-8 rounded-lg flex items-center justify-center border border-slate-100 dark:border-slate-700 hover:border-rose-400 text-slate-400 hover:text-rose-500 transition-all"
                  title="ลบ">
                  <span class="material-icons text-base">delete</span>
                </button>
              </div>
            </td>
          </tr>
          <tr *ngIf="items().length === 0 && !isLoading()">
            <td colspan="6" class="py-20 text-center text-slate-400">
              <span class="material-icons text-4xl mb-2 block">search_off</span>
              <p class="font-bold">ไม่พบข้อมูล</p>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="px-6 py-4 border-t border-slate-100/50 flex flex-col md:flex-row items-center justify-between gap-4">
      <div class="text-sm text-slate-500 font-medium">
        แสดง {{ startItemIndex | number }} - {{ endItemIndex | number }} จาก {{ totalItems() | number }} รายการ
      </div>
      <div class="flex items-center gap-2">
        <button (click)="setPage(currentPage() - 1)" [disabled]="currentPage() === 1"
          class="w-9 h-9 flex items-center justify-center rounded-lg border border-slate-200 dark:border-slate-700 hover:text-amber-500 disabled:opacity-30 transition-all">
          <span class="material-icons text-sm">chevron_left</span>
        </button>
        <button *ngFor="let page of pagesArray" (click)="setPage(page)"
          class="w-9 h-9 flex items-center justify-center rounded-lg text-sm font-bold transition-all"
          [ngClass]="page === currentPage() ? 'bg-amber-400 text-white' : 'text-slate-600 hover:bg-amber-50 dark:hover:bg-amber-900/20'">
          {{ page }}
        </button>
        <button (click)="setPage(currentPage() + 1)" [disabled]="currentPage() === totalPages() || totalPages() === 0"
          class="w-9 h-9 flex items-center justify-center rounded-lg border border-slate-200 dark:border-slate-700 hover:text-amber-500 disabled:opacity-30 transition-all">
          <span class="material-icons text-sm">chevron_right</span>
        </button>
      </div>
    </div>
  </div>
</div>

<app-modal-approval-config *ngIf="isModalOpen()" [configId]="selectedConfigId()"
  (close)="closeModal()" (saveSuccess)="loadTable()"></app-modal-approval-config>

<app-pss-confirm-modal *ngIf="isDeleteConfirmOpen()" title="ยืนยันการลบ?" message="ลบ config"
  [highlight]="deleteTarget()?.name || ''" messageSuffix="หรือไม่?" confirmLabel="ลบข้อมูล" cancelLabel="ยกเลิก"
  variant="danger" icon="delete_forever" (confirm)="confirmDelete()" (cancel)="closeDeleteConfirm()">
</app-pss-confirm-modal>
